module.exports = __webpack_public_path__ + "media/images/fuda03-b8f08e92464bb48600d455ceab1f301b.jpg";